<template>
    <div>
        <a @click="onClick">
            <div class="title-info" style="margin-left: 2px; margin-right: 2px;">
                <div class="v-flex" style="margin-top: -2px"  v-if="state">
                    <div>Wartung {{ state.required }} x p.a.</div>
                    <div
                        class="ml-2 pl-1 pr-1"
                        :class="state.current !== state.required ? 'error' : 'success'"
                    >
                        {{ state.current }} x in {{ state.year }}
                    </div>
                </div>
                <div style="margin-top: -2px;" v-if="last">Letzte Wartung: {{ last }}</div>
            </div>
        </a>
    </div>
</template>

<script>

import moment from "moment";
import Inc from "@/modules/inc/service/Inc";

export default {
    name: "CIncMaintenanceState",
    components: {
    },

    props: {
        site: {
            required: true,
            type    : Object
        }
    },

    data: () => ({
        menuOpen: false,
        state: null
    }),

    watch: {
        site: function () {
            this.load();
        }
    },

    created: function () {
        this.$bus.$on(this.$incident.events.refresh.maintenence, this.load)
    },

    beforeDestroy() {
        this.$bus.$off(this.$incident.events.refresh.maintenence, this.load)
    },

    mounted() {
        this.load();
    },

    computed: {
        last () {
            if (this.state && this.state.last) {
                return this.format(this.state.last.executiondate);
            }

            return null;
        },
    },

    methods: {
        onClick () {
            this.$emit("details")
        },

        load () {
            Inc.maintenance.state(this.site.id).then (data => {
                this.state = data;
            });
        },

        format (value) {
            return moment (value, 'YYYY-MM-DD').format('DD.MM.YYYY');
        },
    }
}
</script>

<style scoped>
.title-info {
    border-radius: 3px;
    height: 25px;
    margin-left: 2px;
    text-align: left;
    font-size: 10pt;
    padding-top: 4px;
    padding-left: 5px;
    padding-right: 5px;
    display: flex;
    justify-content: space-between;
    color: white;
    border-style: solid;
    border-width: 1px;
}

</style>